/**
 * Main JavaScript File
 */

// Template Parts
import { header } from './template-parts/header/header'

// ACF Blocks
import { initTestimonialsSlider } from './template-parts/blocks/testimonials-slider'
import { initHeroBannerSlider } from './template-parts/blocks/hero-banner-slider'
import { initLogosSlider } from './template-parts/blocks/logos-slider'

import { videoBlock, videoOrganizations } from './template-parts/blocks/video'
import { counterNumbers } from './template-parts/blocks/counter-numbers'
import { initTeamBlock } from './template-parts/blocks/team-block'

//utils
import { blogLoadMore } from './utils/blog-loadmore'

// Components
import { appearence } from './components/animations/appearence'

// Utils
import 'bootstrap/js/src/collapse'

// Components
appearence()

// Template Parts
header()

// ACF Blocks
initTestimonialsSlider()
initHeroBannerSlider()
initLogosSlider()
videoBlock()
videoOrganizations()
counterNumbers()
initTeamBlock()
blogLoadMore();

// Utils
// videoSize()
